"use client";

import Svg from "src/assets/icons/Minimize.svg";
import Iconify from "./helpers/Iconify";

const IconMinimize = Iconify(Svg, {
	testID: "IconMinimize",
});
export default IconMinimize;
